import { render, staticRenderFns } from "./Kitchen.vue?vue&type=template&id=01fac418&scoped=true"
import script from "./Kitchen.vue?vue&type=script&lang=js"
export * from "./Kitchen.vue?vue&type=script&lang=js"
import style0 from "./Kitchen.vue?vue&type=style&index=0&id=01fac418&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fac418",
  null
  
)

export default component.exports